import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

const token = localStorage.getItem("token");
 
const echo = new Echo({
    broadcaster: "pusher",
    key: "e82f1b9786be4f824008",
    cluster: "ap2",
    forceTLS: true,
    encrypted: true,
    authEndpoint: "https://react-live.bicpavilion.com/broadcasting/auth",
    auth: {
        headers: {
            Authorization: `Bearer ${token}`
        }
    }
});

// Debug: Log socket ID on connect
echo.connector.pusher.connection.bind('connected', () => {
    console.log("✅ Pusher connected. Socket ID:", echo.socketId());
});

export default echo;
export { echo };
